module.exports = __webpack_public_path__ + "images/DEV_THUMBNAIL_07-938f0a3f92c89b6f087bade88ce51b89.jpg";